import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import {AccessDeniedComponent} from "./views/access-denied/access-denied.component";
import { ErrorComponent } from './views/error/error.component';
import {AuthGuard} from "./guards/auth.guard";
import { fatalGuard } from './guards/fatal.guard';
import {administrationGuard} from "./guards/administration.guard";
import {qualityAuditsGuard} from "./guards/quality-audits.guard";


const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard, fatalGuard],
    canActivateChild: [fatalGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then((m) => m.DashboardModule),
        title: 'Dashboard',
      },
      {
        path: 'ccm/patients',
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'Patients',
          reviewType: 'CCM'
        },
        loadChildren: () => import('./views/ccm/ccmmod/ccmmod.module').then(m => m.CCMModModule),
        title: 'CCM'
      },
      {
        path: 'bhi/patients',
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'Patients',
          reviewType: 'BHI'
        },
        loadChildren: () => import('./views/ccm/ccmmod/ccmmod.module').then(m => m.CCMModModule),
        title: 'BHI'
      },
      {
        path: 'rpm',
        data: {
          breadcrumb: 'RPM Notifications'
        },
        loadChildren: () =>
          import('./views/rpm/rpm.module').then((m) => m.RpmModule),
        title: 'RPM'
      },
      {
        path: 'administration',
        canActivate: [administrationGuard],
        data: {
          breadcrumb: 'Administration'
        },
        loadChildren: () =>
          import('./views/administration/administration.module').then((m) => m.AdministrationModule),
        title: 'Administration'
      },
      {
        path: 'quality-audits',
        canActivate: [qualityAuditsGuard],
        data: {
          breadcrumb: 'Quality Audits'
        },
        loadChildren: () =>
          import('./views/quality-audits/quality-audits.module').then((m) => m.QualityAuditsModule),
        title: 'Quality Audits'
      },
    ]
  },
  {
    path: 'error',
    component: ErrorComponent,
    data: { title: 'Error' }
  },
  {
    path: 'access-denied',
    component: DefaultLayoutComponent,
    data: { title: 'Access Denied' },
    children: [
      { path: '', component: AccessDeniedComponent, title: 'Access Denied' }
    ]
  },
  {path: '**', redirectTo: 'dashboard'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      //initialNavigation: 'enabledBlocking'
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
